import type { ReactNode } from "react";
import { StyleSheet, View, type ViewProps } from "react-native";
import { FieldLabel } from "~/components/form/FieldLabel";
import { Only } from "~/components/permission/Only";
import { Radius, Space } from "~/constants/sizing";
import { useTheme } from "~/providers/ThemeProvider";

type FieldGroupProps = {
    title?: string;
    children: ReactNode;
    zIndex?: number;
    gap?: number;
} & Partial<ViewProps>;

export const FieldGroup = ({ title, children, style, zIndex, gap = Space.xl, ...viewProps }: FieldGroupProps) => {
    const { background } = useTheme();

    const group = () => (
        <View {...viewProps} style={[styles.container, background.primary, { gap, zIndex }, style]}>
            {children}
        </View>
    );

    return (
        <Only when={title} otherwise={group}>
            <FieldLabel label={title}>{group()}</FieldLabel>
        </Only>
    );
};

const styles = StyleSheet.create({
    container: {
        alignItems: "stretch",
        padding: Space.md,
        borderRadius: Radius.lg,
    },
});
